export enum MetadataEntityFieldValidatorType {
    Pattern,
    MinLength,
    MaxLength
}

export interface MetadataEntityFieldValidator {
    type: MetadataEntityFieldValidatorType,
    data?: any;
    message?: any;
}

export const MetadataMinLengthValidator = ((len: number) => ({
    type: MetadataEntityFieldValidatorType.MinLength,
    data: len
})) as { (len: any): MetadataEntityFieldValidator }

export const MetadataMaxLengthValidator = ((len: number) => ({
    type: MetadataEntityFieldValidatorType.MaxLength,
    data: len
})) as { (len: any): MetadataEntityFieldValidator }

export const MetadataRegexValidator = ((pattern: string) => ({
    type: MetadataEntityFieldValidatorType.Pattern,
    data: pattern
})) as { (pattern: string): MetadataEntityFieldValidator } 